import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Header, Button, Icon, Divider, Card, Loader } from 'semantic-ui-react'

import DealCard from './dealCard'
import SpecialDealForm from './forms/newSpecialDealForm'

import SpecialDealActions from '../../reducers/specialDealReducer'

const styles = {
  Container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
  },
  HeaderWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 14px',
  },
  Header: {
    display: 'flex',
    alignItems: 'center',
  },
  AddNewButton: {
    display: 'flex',
    float: 'right',
  },
}

class SpecialDeal extends React.PureComponent {
  state = {
    formVisible: false,
    specialDeal: null,
    action: '',
  }

  componentDidMount() {
    const { getSpecialDeals } = this.props

    getSpecialDeals()
  }

  onView = specialDeal => {
    const { history } = this.props

    history.push({
      pathname: `/promotions/special-deal/${specialDeal.key}`,
      state: { specialDealData: specialDeal },
    })
  }

  onEdit = specialDeal => {
    this.setState({ specialDeal, action: 'edit', formVisible: true })
  }

  onDelete = specialDeal => {
    const { deleteSpecialDeal } = this.props
    const confirm = window.confirm(`Are you sure you want to delete ${specialDeal.title_en}?`)

    if (confirm) {
      deleteSpecialDeal(specialDeal.key)
    }
  }

  renderDealCard = allSpecialDeals => {

    if (_.size(allSpecialDeals) === 0) return <Header textAlign='center' size="small" style={{ padding: 16 }}>No data available</Header>

    return (
      <Card.Group style={{ margin: 0 }}>
        {_.map(allSpecialDeals, (specialDeal, key) => (
          <DealCard
            key={key}
            onDelete={() => this.onDelete(specialDeal)}
            onEdit={() => this.onEdit(specialDeal)}
            onView={() => this.onView(specialDeal)}
            specialDeal={specialDeal}
          />
        ))}
      </Card.Group>
    )
  }

  render() {
    const { formVisible, action, specialDeal } = this.state
    const { specialDealLoading, specialDeals, getSpecialDeals, auth } = this.props

    const region = _.get(auth, 'region')
    const allSpecialDeals = _.filter(specialDeals, deal => deal.region === region)

    if (specialDealLoading) return <Loader active />

    return (
      <div style={styles.Container}>
        <div style={styles.HeaderWrapper}>
          <div style={styles.Header}>
            <Header style={{ marginBottom: 0 }}>{`Special Deals (${_.size(allSpecialDeals)})`}</Header>
          </div>
          <div style={styles.AddNewButton}>
            <Button icon color="black" onClick={() => this.setState({ formVisible: true, action: 'new' })}>
              <Icon name="add" /> Add New
            </Button>
          </div>
        </div>

        <div>
          <Divider style={{ margin: 14 }} />
        </div>

        <div style={{ overflow: 'auto' }}>{this.renderDealCard(allSpecialDeals)}</div>

        {formVisible && (
          <SpecialDealForm
            action={action}
            specialDeal={specialDeal}
            onClose={() =>
              this.setState({ formVisible: false, action: '', specialDeal: null }, () => getSpecialDeals())
            }
          />
        )}
      </div>
    )
  }
}

const mapState = ({ specialDeals, auth }) => ({
  auth: auth.data,
  specialDeals: specialDeals.data,
  specialDealLoading: specialDeals.loading,
})

const mapDispatch = {
  getSpecialDeals: SpecialDealActions.getSpecialDeals,
  deleteSpecialDeal: SpecialDealActions.deleteSpecialDeal,
}

export default connect(
  mapState,
  mapDispatch
)(withRouter(SpecialDeal))



// WEBPACK FOOTER //
// ./src/components/specialDeal/index.js